import React from "react";
import { motion } from "framer-motion";

const PORTRAIT = "https://customer-assets.emergentagent.com/job_sircs-test/artifacts/ewc2vcyj_093EFD2A-7153-4619-BC41-71EC42F5F297.png";

export default function SantiSection() {
  return (
    <section
      id="santi"
      className="section-cream relative py-24 md:py-40 overflow-hidden"
      data-testid="santi-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 1 }}
            className="lg:col-span-6 order-2 lg:order-1"
          >
            <div
              className="relative overflow-hidden rounded-md"
              style={{
                height: "560px",
                boxShadow:
                  "0 30px 60px -15px rgba(11,14,19,0.25), 0 0 60px -20px rgba(199,170,120,0.30)",
              }}
              data-testid="santi-portrait"
            >
              <img
                src={PORTRAIT}
                alt="Santi Lorenzo · Creador del Método SIRCS"
                className="h-full w-full object-cover object-top photo-treated"
                draggable={false}
                loading="lazy"
              />
              <div
                className="absolute inset-0 pointer-events-none"
                style={{
                  background:
                    "linear-gradient(135deg, rgba(11,14,19,0.10), transparent 55%, transparent 70%, rgba(199,170,120,0.10))",
                }}
              />
              <div className="absolute top-4 left-4 h-4 w-4 border-l-2 border-t-2 border-[#6E7580]" />
              <div className="absolute top-4 right-4 h-4 w-4 border-r-2 border-t-2 border-[#6E7580]" />
              <div className="absolute bottom-4 left-4 h-4 w-4 border-l-2 border-b-2 border-[#6E7580]" />
              <div className="absolute bottom-4 right-4 h-4 w-4 border-r-2 border-b-2 border-[#6E7580]" />
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="lg:col-span-6 order-1 lg:order-2"
          >
            <p className="overline mb-6">◇ Sobre el mentor</p>
            <h2 className="font-serif font-normal text-5xl sm:text-6xl lg:text-7xl text-[#0B0E13] leading-[1.02] tracking-[-0.01em]">
              Santi
              <br />
              <span className="italic text-[#6E7580]">Lorenzo</span>
            </h2>
            <div className="gold-divider my-10" />
            <p className="text-[#2A303A] leading-[1.7] text-lg sm:text-xl font-light font-sans">
              Creador del Método SIRCS — Sistema Integral de Reprogramación Consciente y
              Subconsciente. Un método propio construido tras más de una década uniendo PNL,
              hipnosis, inteligencia emocional y disciplina militar.
            </p>
            <p className="mt-6 text-[#3A414C] leading-[1.7] text-base font-light font-sans">
              Fundador de la Escuela Internacional de Transformación. Trabajo desde las
              cicatrices, no desde los libros — con procesos estructurados para personas que ya
              no buscan frases bonitas, sino método.
            </p>

            <div className="mt-10 grid grid-cols-2 gap-6">
              <div className="border-l-2 border-[#C7AA78]/70 pl-5">
                <p className="font-serif text-5xl text-[#0B0E13] leading-none">+25</p>
                <p className="text-xs text-[#6E7580] uppercase tracking-[0.22em] mt-3 font-medium font-sans">
                  Años de disciplina y liderazgo
                </p>
              </div>
              <div className="border-l-2 border-[#C7AA78]/70 pl-5">
                <p className="font-serif text-5xl text-[#0B0E13] leading-none">+10</p>
                <p className="text-xs text-[#6E7580] uppercase tracking-[0.22em] mt-3 font-medium font-sans">
                  Años estudiando comportamiento humano
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
